import Api from 'src/services/api'
import { date as dateUtils } from 'quasar'

const getDateDefault = () => {
  let date = dateUtils.addToDate(new Date(), { hours: 1 })

  date = dateUtils.formatDate(date, 'YYYY-MM-DD')
  return date
}

const getAvailableTimes = (data = {}) => {
  let { sessions } = (data && data.days[0]) || {}
  let allTimes = []

  if (sessions) {
    allTimes = sessions.reduce((accumulator, session) => {
      let times = session.seating_areas && session.seating_areas[0].times
      times = times.filter(item => (item.is_available && !item.online_suspended))
      accumulator.push(...times)
      return accumulator
    }, [])
  }

  return allTimes
}

const getRangeFromResponses = (data = {}) => {
  const filteredData = Object.keys(data).reduce((accumulator, key) => {
    const availableTimes = getAvailableTimes(data[key])
    if (availableTimes && availableTimes.length) {
      accumulator[key] = availableTimes
    }
    return accumulator
  }, {})

  const filteredKeys = Object.keys(filteredData).map(v => +v)

  return {
    min: Math.min(...filteredKeys),
    max: Math.max(...filteredKeys)
  }
}

const getDefaultState = () => {
  return {
    sid: null,
    conf: null,
    form: {
      id: null,
      party_size: 2,
      date: getDateDefault(),
      session: 'lunch',
      location: '',
      timeSlot: '',
      wheelchair_users: false,
      child_seats: 0
    },
    userForm: {
      first_name: '',
      last_name: '',
      phone_number: '',
      email: '',
      subscribed: false
    },
    partySizeRanges: {
      min: 1,
      max: 14
    }
  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE (state) {
    Object.assign(state, getDefaultState())
  },
  SET_FORM_ITEM: (state, { key, value }) => {
    if (state.form.hasOwnProperty(key)) {
      state.form[key] = value
    }
  },
  SET_FORM_DATA: (state, { data }) => {
    state.form = {
      ...state.form,
      ...data
    }
  },
  SET_USER_FORM_DATA: (state, { data }) => {
    state.userForm = {
      ...state.userForm,
      ...data
    }
  },
  SET_SID: (state, sid = null) => {
    state.sid = sid
  },
  SET_PARTY_SIZE_RANGES: (state, { min = 1, max = 8 }) => {
    state.partySizeRanges = {
      min,
      max
    }
  }
}

const actions = {
  resetState ({ commit }) {
    commit('RESET_STATE')
  },
  init ({ commit, dispatch }, payload) {
    let { sid, conf, data } = payload

    commit('SET_SID', sid)
    dispatch('fetchReservation', {
      sid,
      conf
    })
    commit('SET_FORM_DATA', data)
  },
  fetchReservation ({ commit }, payload) {
    return Api.fetchReservation(payload)
      .then(
        ({ data }) => {
          commit('SET_FORM_DATA', data)
          return data
        },
        ({ response = {} }) => {
          return response.data
        }
      )
  },
  setFormItem ({ commit }, payload) {
    commit('SET_FORM_ITEM', payload)
  },
  setFormData ({ commit }, payload) {
    commit('SET_FORM_DATA', payload)
  },
  setUserFormData ({ commit }, payload) {
    commit('SET_USER_FORM_DATA', payload)
  },
  minePartySizeRanges ({ commit, state }, payload = {}) {
    let { sid } = payload
    let { location, date } = state.form
    sid = sid || location

    Api.getReservationsAvailability(sid, {
      party_size: '1,2,3,4,5,6,7,8,10,11,12,13,14,15,16,17,18,19,20,21',
      date
    })
      .then((response) => {
        const { data = {} } = response
        const range = getRangeFromResponses(data)
        commit('SET_PARTY_SIZE_RANGES', range)
      })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
